import cogoToast from "cogo-toast";
import httpRequest from "../../ajax";

import {
  CREATE_FEED_POST,
  GET_FEEDS_RESULTS,
  CREATE_COMMENT_POST,
  DELETE_FEEDS_CATEGORY,
  DELETE_COMMENT,
  SET_POST_COMMENTS,
  ERROR
} from "../actionTypes";

/**
 * Community tab actions — backed by /community/posts (user_posts table).
 * Posts are platform-wide (not company-scoped), per PRD §7.1/§9.
 */

export const createFeedAction = (dispatch, data) => {
  const body = { body: data.content, image_urls: data.img_url ? [data.img_url] : [] };
  return httpRequest("post", "/community/posts", body)
    .then((response) => {
      const responseData = response.data?.data;
      if (responseData) {
        const payload = { ...responseData, comments: [] };
        dispatch({ type: CREATE_FEED_POST, payload });
        return { success: true, payload };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create post';
      dispatch({ type: ERROR, payload: errorMessage });
      throw new Error(errorMessage);
    });
};

export const createCommentPostAction = (dispatch, data) => {
  return httpRequest("post", `/community/posts/${data.feed_id}/comments`, { body: data.content })
    .then((response) => {
      const responseData = response.data?.data;
      if (responseData) {
        const payload = { ...responseData, feed_id: data.feed_id };
        dispatch({ type: CREATE_COMMENT_POST, payload });
        return { success: true, payload };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create comment';
      dispatch({ type: ERROR, payload: errorMessage });
      throw new Error(errorMessage);
    });
};

export const getFeedsAction = (dispatch, page = 1) => {
  return httpRequest("get", `/community/posts?page=${page}`)
    .then((response) => {
      const responseData = response.data?.data;
      if (responseData) {
        dispatch({ type: GET_FEEDS_RESULTS, payload: responseData });
        return { success: true, payload: responseData };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch feeds';
      dispatch({ type: ERROR, payload: errorMessage });
      throw new Error(errorMessage);
    });
};

/**
 * fetchPostCommentsAction — lazily load comments for a post when its
 * comments panel is expanded (comments are not embedded in the list
 * response for performance).
 */
export const fetchPostCommentsAction = (dispatch, postId) => {
  return httpRequest("get", `/community/posts/${postId}/comments`)
    .then((response) => {
      const responseData = response.data?.data || [];
      dispatch({ type: SET_POST_COMMENTS, payload: { feed_id: postId, comments: responseData } });
      return { success: true, payload: responseData };
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch comments';
      dispatch({ type: ERROR, payload: errorMessage });
      throw new Error(errorMessage);
    });
};

export const deleteFeedsAction = (dispatch, data) => {
  return httpRequest("delete", `/community/posts/${data.item_id}`)
    .then(() => {
      const payload = { id: data.item_id };
      dispatch({ type: DELETE_FEEDS_CATEGORY, payload });
      return { success: true, payload };
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete feed';
      dispatch({ type: ERROR, payload: errorMessage });
      throw new Error(errorMessage);
    });
};

export const deleteCommentAction = (dispatch, data) => {
  return httpRequest("delete", `/community/posts/${data.feed_id}/comments/${data.comment_id}`)
    .then(() => {
      const payload = { comment_id: data.comment_id, feed_id: data.feed_id };
      dispatch({ type: DELETE_COMMENT, payload });
      return { success: true, payload };
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete comment';
      dispatch({ type: ERROR, payload: errorMessage });
      throw new Error(errorMessage);
    });
};

/**
 * toggleFeedLikeAction — like or unlike a post.
 * Calls POST /community/posts/{id}/like or DELETE .../like depending
 * on the post's current liked_by_me state.
 */
export const toggleFeedLikeAction = (dispatch, feedId, likedByMe) => {
  const method = likedByMe ? "delete" : "post";
  return httpRequest(method, `/community/posts/${feedId}/like`)
    .then((response) => {
      const responseData = response.data?.data;
      if (responseData) {
        dispatch({
          type: "TOGGLE_FEED_LIKE",
          payload: {
            id: feedId,
            likes: responseData.like_count,
            liked_by_me: responseData.liked_by_me,
          },
        });
      }
      return { success: true, payload: responseData };
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to toggle like';
      cogoToast.error(errorMessage, { position: "top-center", hideAfter: 3 });
      throw new Error(errorMessage);
    });
};
